import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_CONTRATISTA_RESPONSABLE, ROW_COUNT, API_ADMIN_GERENCIA } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import IGerencia from "../../../entities/IGerencia";
import ISubContratista from "../../../entities/ISubContratista";
import ContratistasResponsable from "../../../entities/IContratistasResponsable";
import CscService from "../../../services/CscService";
import { cParamsActiveOrderTitle, cParamsPageSize } from "../../../helpers/paramsHelper";

interface ContratistaSubContratista {
  cbGerencia?: Array<IGerencia>;
  cbSubContratista?: Array<ISubContratista>;
  items?: Array<any>;
}

const ContratistaSubContratista = ({ cbGerencia, cbSubContratista, items }: ContratistaSubContratista) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboGrc, setComboGrc] = useState<Array<IGerencia>>(cbGerencia || []);
  const [comboCsc, setComboCsc] = useState<Array<ISubContratista>>(cbSubContratista || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = cParamsPageSize(pageSize);
    let result =
      items !== undefined
        ? { data: items, pages: 10 }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_RESPONSABLE}/getall?PAGINA=1&PAGINADO=10`,
              { Authorization: `Bearer ${token}` },
              params
            )
          ).result;
    let list = result.data;
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);
    setListItems(list);
    const comboGrc = (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle))
      .result.data;
    setComboGrc(comboGrc);

    const comboCsc = (await CscService.getAll(token, cParamsActiveOrderTitle)).result.data;
    setComboCsc(comboCsc);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = (filter: Partial<ContratistasResponsable>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }

    filter.CONTRATISTA = filter.ID_CONTRATISTA_SUBCONTRATISTA?.toString() || "";
    filter.GERENCIA = filter.ID_GERENCIA_SUBGERENCIA?.toString() || "";

    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: ContratistasResponsable, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.ID_CONTRATISTA_SUBCONTRATISTA = value.ID_CONTRATISTA_SUBCONTRATISTA || 1;
    value.ID_GERENCIA_SUBGERENCIA = value.ID_GERENCIA_SUBGERENCIA || 1;
    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_CONTRATISTA_RESPONSABLE}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
              CONTRATISTA: "",
              GERENCIA: "",
              ID_CONTRATISTA_SUBCONTRATISTA: 1,
              ID_GERENCIA_SUBGERENCIA: 1,
              PREVENCIONISTA: "",
              PREVENCIONISTA_DISPLAY: "",
              RESPONSABLE: "",
              RESPONSABLE_DISPLAY: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_GERENCIA_SUBGERENCIA",
            value: comboGrc.map((grc) => {
              return { text: grc.TITULO, value: grc.ID };
            }),
          },
          {
            type: "ID_CONTRATISTA_SUBCONTRATISTA",
            value: comboCsc.map((csc) => {
              return { text: csc.TITULO, value: csc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"ContratistasResponsables"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Contratistas responsables"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default ContratistaSubContratista;
